import { graphql } from '~/gql'

const DELETE_VERSION_MUTATION = graphql(`
  mutation DeleteVersion($id: ID!) {
    deleteVersion(id: $id) {
      id
    }
  }
`)

export default DELETE_VERSION_MUTATION
